/* Custom Reaven — switcher griglia collezione (restyling 2026).
   Due scope indipendenti: desktop (3/4/6 colonne) e mobile/tablet (1/2/4,
   classi grid--N-col-tablet-down; il default resta columns_mobile della
   sezione). Riscrive le classi colonna su #product-grid, persiste la scelta
   in localStorage e la riapplica dopo ogni re-render dei facets
   (evento 'facets:rendered'). */

if (!customElements.get('grid-switcher')) {
  customElements.define(
    'grid-switcher',
    class GridSwitcher extends HTMLElement {
      static STORAGE_PREFIX = 'reaven:grid-view:';
      static SCOPES = {
        desktop: { allowed: [3, 4, 6], suffix: 'desktop' },
        mobile: { allowed: [1, 2, 4], suffix: 'tablet-down' },
      };

      connectedCallback() {
        this.current = {};
        this.buttons = Array.from(this.querySelectorAll('button[data-columns][data-scope]'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => {
            this.select(button.dataset.scope, parseInt(button.dataset.columns, 10), true);
          });
        });

        this.onFacetsRendered = () => this.apply();
        document.addEventListener('facets:rendered', this.onFacetsRendered);

        Object.keys(GridSwitcher.SCOPES).forEach((scope) => {
          let saved = NaN;
          try {
            saved = parseInt(localStorage.getItem(GridSwitcher.STORAGE_PREFIX + scope), 10);
          } catch (error) {
            // localStorage non disponibile (es. navigazione privata): si usa il default della sezione
          }
          if (GridSwitcher.SCOPES[scope].allowed.includes(saved)) {
            this.current[scope] = saved;
          }
        });

        this.apply();
      }

      disconnectedCallback() {
        document.removeEventListener('facets:rendered', this.onFacetsRendered);
      }

      select(scope, columns, persist) {
        const config = GridSwitcher.SCOPES[scope];
        if (!config || !config.allowed.includes(columns)) return;
        this.current[scope] = columns;
        if (persist) {
          try {
            localStorage.setItem(GridSwitcher.STORAGE_PREFIX + scope, String(columns));
          } catch (error) {
            // ignora: la scelta vale solo per la pagina corrente
          }
        }
        this.apply();
      }

      // Colonne attive per scope: scelta salvata, altrimenti quella impostata dalla sezione
      currentFor(scope, grid) {
        if (this.current[scope]) return this.current[scope];
        const suffix = GridSwitcher.SCOPES[scope].suffix;
        const match = Array.from(grid.classList).find((name) => new RegExp(`^grid--\\d-col-${suffix}$`).test(name));
        return match ? parseInt(match.replace('grid--', ''), 10) : null;
      }

      // La griglia: in collezione #product-grid è la <ul>, nella ricerca è un wrapper con la <ul> dentro
      grid() {
        const el = document.getElementById('product-grid');
        if (!el) return null;
        return el.tagName === 'UL' ? el : el.querySelector('ul.grid');
      }

      apply() {
        const grid = this.grid();
        if (!grid) return;

        Object.keys(GridSwitcher.SCOPES).forEach((scope) => {
          const suffix = GridSwitcher.SCOPES[scope].suffix;
          const columns = this.currentFor(scope, grid);
          if (!columns) return;

          Array.from(grid.classList)
            .filter((name) => new RegExp(`^grid--\\d-col-${suffix}$`).test(name))
            .forEach((name) => grid.classList.remove(name));
          grid.classList.add(`grid--${columns}-col-${suffix}`);

          this.buttons
            .filter((button) => button.dataset.scope === scope)
            .forEach((button) => {
              button.setAttribute('aria-pressed', String(parseInt(button.dataset.columns, 10) === columns));
            });
        });
      }
    }
  );
}
